import { render, staticRenderFns } from "./prdtype_sel.vue?vue&type=template&id=5cb0988c&scoped=true&"
import script from "./prdtype_sel.vue?vue&type=script&lang=js&"
export * from "./prdtype_sel.vue?vue&type=script&lang=js&"
import style0 from "./prdtype_sel.vue?vue&type=style&index=0&id=5cb0988c&scoped=true&lang=less&"
import style1 from "./prdtype_sel.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb0988c",
  null
  
)

export default component.exports